export default "__VITE_ASSET__Dm_$frjp__"